import { Injectable } from '@angular/core';
import { Adapter } from 'src/utils/interfaces/adapter-service.interfaces';
import { MeasurementSettingsFormData } from 'src/utils/interfaces/rotor-type-forms-data.interfaces';
import { FilterParameterUnbalance } from 'src/utils/interfaces/rotor-type.interfaces';
import { mapToRotorTypeValue, mapToRotorTypeValueV2 } from './adapter.mappers';
import { UnitsV2 } from '@schenck/rotec-components';
import { FilterQualityTypes } from 'src/utils/enums/rotor-type.enum';

@Injectable({
  providedIn: 'root',
})
export class FilterParameterUnbalanceAdapter
  implements Adapter<MeasurementSettingsFormData, FilterParameterUnbalance>
{
  /**
   * Creates the adapted form data for measurement settings step
   *
   * @param formData: MeasurementSettingsFormData
   * @param units: UnisV2[]
   * @returns FilterParameterUnbalance
   */
  adapt(formData: MeasurementSettingsFormData, units: UnitsV2[]): FilterParameterUnbalance {
    return {
      filterQuality: mapToRotorTypeValueV2<FilterQualityTypes>({
        name: 'filterQuality',
        value: formData.filterQuality,
      }),
      readoutRetention: mapToRotorTypeValueV2({
        name: 'readoutRetention',
        value: formData.readoutRetention,
      }),
      filterDelay: mapToRotorTypeValue(formData.filterDelay, units),
      ...(formData.filterQuality === FilterQualityTypes.Continuous && {
        filterTime: mapToRotorTypeValue(formData.filterTime, units),
      }),
      enableAverageOverTime: {
        name: 'enableAverageOverTime',
        value: formData.enableAverageOverTime,
        isEdited: true,
      },
      averageTime: formData.averageTime && mapToRotorTypeValue(formData.averageTime, units),
    };
  }
}
